export const KEY_FILTER_ADDON_CATEGORY_ID = 'filter[add_on_category_id]';
export const KEY_FILTER_PRODUCT_CATEGORY_ID = 'filter[add_on_product_id]';
export const KEY_FILTER_NAME = 'filter[name]';
export const KEY_FILTER_FIRST_NAME = 'filter[first_name]';
export const KEY_FILTER_CATEGORY_ID = 'filter[category_id]';
export const KEY_FILTER_TYPE = 'filter[type]';
export const KEY_FILTER_BUSINESS_ID = 'filter[business_id]';
export const KEY_FILTER_STATUS = 'filter[status]';
export const KEY_FILTER_EMAIL = 'filter[email]';
